import { render, staticRenderFns } from "./WildHeartsPlatformsList.vue?vue&type=template&id=c00d2b94&lang=pug&"
import script from "./WildHeartsPlatformsList.vue?vue&type=script&lang=js&"
export * from "./WildHeartsPlatformsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports